import { render, staticRenderFns } from "./ApiDataSourceWizard.vue?vue&type=template&id=afb5ee18&scoped=true"
import script from "./ApiDataSourceWizard.vue?vue&type=script&lang=js"
export * from "./ApiDataSourceWizard.vue?vue&type=script&lang=js"
import style0 from "./ApiDataSourceWizard.vue?vue&type=style&index=0&id=afb5ee18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb5ee18",
  null
  
)

export default component.exports